import ReportButtonAdmin from "../components/ReportButtonAdmin/ReportButtonAdmin";
import NavbarDashboard from "../components/navbarDashboard/NavbarDashboard";
import AdminDepCard from "../components/AdminDepCard/AdminDepCard";
import * as React from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Select, MenuItem, Button, Stack, Typography, Alert } from "@mui/material";
import axios from "axios";
import { saveAs } from "file-saver";

const API_URL = process.env.REACT_APP_API_URL;

export default function AdminEditPage() {
  const { currentYear, currentQuarter } = useParams();
  const navigate = useNavigate();
  const [allDepts, setAllDepts] = React.useState([]);
  const [selectedDept, setSelectedDept] = React.useState("");
  const [error, setError] = React.useState(null);

  React.useEffect(() => {
    const token = localStorage.getItem("jwt");
    console.log("JWT Token:", token); // Debug token
    if (!token) {
      setError("No authentication token found. Please log in.");
      navigate("/login");
      return;
    }

    const requestOptions = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    fetch(
      `${API_URL}/api/admin/report/${currentYear}/${currentQuarter}`,
      requestOptions
    )
      .then((response) => {
        if (!response.ok) {
          if (response.status === 401) {
            throw new Error("Unauthorized: Please log in again.");
          }
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        return response.json();
      })
      .then((data) => {
        console.log("allDepts:", JSON.stringify(data, null, 2)); // Debug department data
        setAllDepts(data);
        if (data.length > 0) {
          setSelectedDept(data[0].id); // Default to first department
        }
      })
      .catch((error) => {
        console.error("Error during fetch all dept in admin!", error);
        setError(`Failed to fetch departments: ${error.message}`);
        if (error.message.includes("Unauthorized")) {
          navigate("/login");
        }
      });
  }, [currentYear, currentQuarter, navigate]);

  const handleDownload = async () => {
    if (!selectedDept) {
      setError("Please select a department");
      return;
    }

    const token = localStorage.getItem("jwt");
    console.log("JWT Token for download:", token); // Debug token
    if (!token) {
      setError("No authentication token found. Please log in.");
      navigate("/login");
      return;
    }

    try {
      const response = await axios.get(
        `${API_URL}/api/admin/department/${selectedDept}/report/${currentYear}/${currentQuarter}/download`,
        {
          responseType: "blob",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      const blob = new Blob([response.data], { type: "application/zip" });
      saveAs(blob, `${selectedDept}_report_${currentYear}_${currentQuarter}.zip`);
      setError(null);
    } catch (error) {
      console.error("Error downloading department report:", error);
      if (error.response && error.response.status === 401) {
        setError("Unauthorized: Please log in again.");
        navigate("/login");
      } else if (error.response && error.response.status === 404) {
        setError(`Report for department ${selectedDept} is not completed or does not exist.`);
      } else {
        setError(`Failed to download report for department ${selectedDept}: ${error.message}`);
      }
    }
  };

  const handleSubmit = (selectedDate, id) => {
    const token = localStorage.getItem("jwt");
    console.log("JWT Token for extend:", token); // Debug token
    if (!token) {
      setError("No authentication token found. Please log in.");
      navigate("/login");
      return;
    }

    const date = selectedDate.$d.toISOString().slice(0, -5) + "Z";
    const requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({ deadline: date }),
    };
    fetch(
      `${API_URL}/api/admin/department/${id}/extend`,
      requestOptions
    )
      .then((response) => {
        if (!response.ok) {
          if (response.status === 401) {
            throw new Error("Unauthorized: Please log in again.");
          }
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        return response.json();
      })
      .then((data) => {
        console.log("Deadline extended...", data);
      })
      .catch((error) => {
        console.error("Error during extending the deadline", error);
        setError(`Failed to extend deadline for department ${id}: ${error.message}`);
        if (error.message.includes("Unauthorized")) {
          navigate("/login");
        }
      });
  };

  return (
    <>
      <NavbarDashboard />
      <div style={{ marginTop: "7%", marginBottom: "20px", marginLeft: "5%" }}>
        <Stack direction="row" spacing={2} alignItems="center">
          <Typography variant="h6" sx={{ color: "#FFFFFF", fontFamily: "Montserrat, sans-serif" }}>
            Select Department:
          </Typography>
          <Select
            value={selectedDept}
            onChange={(e) => setSelectedDept(e.target.value)}
            sx={{
              backgroundColor: "#FFFFFF",
              color: "#000000",
              fontFamily: "Montserrat, sans-serif",
              minWidth: 150,
            }}
          >
            {allDepts.map((dept) => (
              <MenuItem key={dept.id} value={dept.id}>
                {dept.id} 
              </MenuItem>
            ))}
          </Select>
          <Button
            variant="contained"
            onClick={handleDownload}
            sx={{
              backgroundColor: "#067094",
              color: "#FFFFFF",
              fontFamily: "Montserrat, sans-serif",
              "&:hover": { backgroundColor: "#14475D" },
            }}
          >
            Download Report
          </Button>
        </Stack>
        {error && (
          <Alert severity="error" sx={{ marginTop: "10px", width: "fit-content" }}>
            {error}
          </Alert>
        )}
      </div>
      <div className="grid-container" style={{ marginTop: "2%", marginLeft: "5%" }}>
        {allDepts.map((card, index) => (
          <AdminDepCard
            key={index}
            title={card.id}
            content={
              card.reports[0] && card.reports[0].stage === "ACTION_COMPLETED"
                ? "Completed"
                : "In Progress"
            }
            onSubmit={handleSubmit}
          />
        ))}
      </div>
    </>
  );
}